import {useEffect, useRef, useState} from "react";
import {Alert, Button, Stack, TextField, Typography} from "@mui/material";
import {useDialog} from "muibox";
import useFeedback from "../../components/feedback/useFeedback";
import {
    consultarAlteracaoPosse,
    usePrepararAlteracaoPosse
} from "../../api/DpgeIntegracaoEsfingeApi";
import {referenciaCompetencia} from "./IngressoEstatutarioPanel";
import OcorrenciasGeradas from "./OcorrenciasGeradas";

const campos = {
    numeroEspecialidade: "Especialidade",
    numeroInscricao: "Inscrição",
    codigoCargo: "Cargo",
    tipoQuadro: "Quadro",
    dataInicioVigencia: "Vigência do cargo",
    tipoAlteracaoPosse: "Tipo de alteração (Tabela 99)",
    dataOcorrenciaAlteracao: "Data da ocorrência",
    dataPosse: "Nova data de posse"
};
export default function AlteracaoPossePanel({anoMes}) {
    const [historico, setHistorico] = useState("");
    const [diagnostico, setDiagnostico] = useState(null);
    const [ocorrencias, setOcorrencias] = useState([]);
    const [ocupado, setOcupado] = useState(false);
    const lock = useRef(false),
        ativo = useRef(true);
    const referencia = referenciaCompetencia(anoMes);
    const dialog = useDialog(),
        {showError} = useFeedback();
    const preparacao = usePrepararAlteracaoPosse();
    useEffect(() => {
        ativo.current = true;
        return () => {
            ativo.current = false;
        };
    }, []);
    async function executar(preparar) {
        if (lock.current) return;
        lock.current = true;
        setOcupado(true);
        try {
            if (preparar) {
                try {
                    await dialog.confirm({
                        title: "Preparar alteração de posse para aprovação?",
                        ok: {text: "CONFIRMAR", color: "primary"},
                        cancel: {text: "CANCELAR", color: "primary"}
                    });
                } catch (e) {
                    return;
                }
                if (!ativo.current) return;
                const resposta = await preparacao.mutateAsync({
                    historico: diagnostico.historicoFolha,
                    referencia
                });
                if (ativo.current) setOcorrencias([resposta.data]);
            } else {
                setDiagnostico(null);
                setOcorrencias([]);
                const resposta = await consultarAlteracaoPosse(
                    historico.trim(),
                    referencia
                );
                if (ativo.current) setDiagnostico(resposta.data);
            }
        } catch (erro) {
            if (ativo.current) showError(erro);
        } finally {
            lock.current = false;
            if (ativo.current) setOcupado(false);
        }
    }
    return (
        <Stack spacing={2}>
            <Typography variant="h6">
                Alteração da posse / desistência
            </Typography>
            <Alert severity="info">
                Use somente quando houver alteração registrada no candidato do
                concurso na Folha. O resultado do concurso e as alterações
                anteriores devem estar aceitos. A preparação preserva os aceites
                e não autoriza o envio. Não se aplica à nomeação em comissão sem
                concurso.
            </Alert>
            <TextField
                label="Identificador do histórico na Folha"
                value={historico}
                disabled={ocupado}
                helperText="Consulte o histórico do candidato no concurso ou pelo atalho em Dados Funcionais."
                onChange={(e) => {
                    setHistorico(e.target.value);
                    setDiagnostico(null);
                    setOcorrencias([]);
                }}
            />
            <Button
                variant="outlined"
                disabled={
                    ocupado ||
                    !referencia ||
                    !/^[1-9][0-9]*$/.test(historico.trim())
                }
                onClick={() => executar(false)}
            >
                Conferir alteração de posse
            </Button>
            {diagnostico && (
                <>
                    <TextField
                        label="Edital"
                        value={diagnostico.pacote?.numeroEdital || ""}
                        InputProps={{readOnly: true}}
                    />
                    {Object.entries(campos).map(([campo, label]) => (
                        <TextField
                            key={campo}
                            label={label}
                            value={
                                diagnostico.pacote?.alteracoes?.[0]?.[campo] ||
                                ""
                            }
                            InputProps={{readOnly: true}}
                        />
                    ))}
                    {!!diagnostico.pendencias?.length && (
                        <Alert severity="warning">
                            <ul>
                                {diagnostico.pendencias.map((p) => (
                                    <li key={p}>{p}</li>
                                ))}
                            </ul>
                            Confira o registro na Folha. O conector não altera o
                            histórico.
                        </Alert>
                    )}
                    <Button
                        variant="contained"
                        disabled={ocupado || !!diagnostico.pendencias?.length}
                        onClick={() => executar(true)}
                    >
                        Preparar alteração de posse
                    </Button>
                </>
            )}
            <OcorrenciasGeradas ocorrencias={ocorrencias} />
        </Stack>
    );
}
